import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { appRoutes } from './routes';
import { registerAuthGuard } from './authGuard';
import { forceRedirectToClearCache } from './forceRedirect';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: appRoutes as RouteRecordRaw[]
});

registerAuthGuard(router);
forceRedirectToClearCache(router);

export default router;
